/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_Select_Day_HintInputs */



/**
* | output |
* | --- |
* | "Click a day to show its events" |
*
* @param {Connectivity_History_Select_Day_HintInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_select_day_hint = /** @type {((inputs?: Connectivity_History_Select_Day_HintInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Select_Day_HintInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Click a day to show its events")
	return /** @type {LocalizedString} */ ("Cliquez sur un jour pour afficher ses événements")
});